import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["teamIds"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useQuery } from 'react-query';
import api from 'utils/api';
import getFullUserName from 'utils/getFullUserName';
import { teamQueryKeys } from '.';
function formatManagerData(obj) {
  var fullUserName = getFullUserName(obj);
  var displayName = fullUserName || obj.name;
  return {
    id: obj.id,
    displayName: displayName
  };
}
function useFetchTeamManagers(_ref) {
  var teamIds = _ref.teamIds,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchTeamManagers() {
    return _fetchTeamManagers.apply(this, arguments);
  }
  function _fetchTeamManagers() {
    _fetchTeamManagers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$api, items, formatted;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api('get', '/api/query/users', {
              fields: ['id', 'first_name', 'last_name', 'name'],
              filter: {
                userTeams: {
                  team_id: teamIds,
                  role: 'manager'
                }
              },
              orderby: 'name'
            });
          case 2:
            _yield$api = _context.sent;
            items = _yield$api.items;
            formatted = items.map(formatManagerData);
            return _context.abrupt("return", formatted);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchTeamManagers.apply(this, arguments);
  }
  var _useQuery = useQuery(teamQueryKeys.teamManagers(teamIds), fetchTeamManagers, queryOptions),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    items: data
  }, result);
}
export default useFetchTeamManagers;